import { Popover, Button, Checkbox, Row, Input, Space, Divider } from "antd"
import {QueryField} from "../types/Query";
import {DragCurrent} from "./types/DragCurrent";
import { useDraggable } from "@dnd-kit/core";
import React, { useState } from "react";
import buttonStyles from '../../../components/common/styled/Buttons.module.scss';
import styles from './Visualisations.module.scss'
import { CaretDownOutlined } from "@ant-design/icons";
import {QueryMetaData} from "../types/QueryMetaData";
import { Spin } from "antd/es";

type SelectFilterProps = {
    field: QueryField,
    queryMetaData: QueryMetaData,
    appliedFilters: string[]
    setAppliedFilters: (appliedFilters: string[]) => void
}

const getAllCodes = (field: QueryField, queryMetaData: QueryMetaData): string[] => {
    return (Object.values(queryMetaData.fieldValues[field.code])
        .map(fieldValue => fieldValue.code))
}

const SelectFilter = ({field, queryMetaData, appliedFilters, setAppliedFilters}: SelectFilterProps) => {
    const title = queryMetaData.fields[field.code].name
    const filterCount = Object.keys(queryMetaData.fieldValues[field.code]).length
    const [refineText, setRefineText] = useState<string>('')

    return <div>
        <Row className={styles['select-filters-title']}><strong>{title}</strong> ({filterCount})</Row>
        <Divider className={styles['select-filters-title-divider']}/>
        <Row className={styles['select-filters-refiner']}>
            <Input onChange={e => setRefineText(e.target.value)} placeholder="Filter Values"/>
        </Row>
        <Row className={styles['select-filters-all-none']}>
            <Space>
                <Button
                    className={styles['select-filters-all-none-button']}
                    onClick={() => {setAppliedFilters([])}}
                >
                    Select All
                </Button>
                <Button
                    className={styles['select-filters-all-none-button']}
                    onClick={() => {
                        setAppliedFilters(getAllCodes(field, queryMetaData))
                    }}
                >
                    Select None
                </Button>
            </Space>
        </Row>
        <Row className={filterCount > 8 ? styles['filter-values-scroll'] : undefined}>
            <Space direction="vertical">
                {Object.values(queryMetaData.fieldValues[field.code])
                    .filter(fieldValue => fieldValue.name.toUpperCase().includes(refineText.toUpperCase()))
                    .map(fieldValue => {
                        const checked = !appliedFilters.includes(fieldValue.code)

                        return <Checkbox
                            key={fieldValue.code}
                            checked={checked}
                            onChange={() => {
                                const newAppliedValues = checked ? [...appliedFilters, fieldValue.code] :
                                    appliedFilters.filter(appliedFilter => appliedFilter  !== fieldValue.code)
                                setAppliedFilters(newAppliedValues)
                            }}
                        >
                            {fieldValue.name}
                        </Checkbox>;
                    })
                }
            </Space>
        </Row>
    </div>
}

export type SelectFieldProps = {
    queryMetaData?: QueryMetaData
    field: QueryField
    from: DragCurrent["from"]
    appliedFilters: string[]
    setAppliedFilters: (appliedFilters: string[]) => void
}

export const SelectField = ({queryMetaData, field, from, appliedFilters, setAppliedFilters}: SelectFieldProps) => {

    const {attributes, listeners, setNodeRef, transform} = useDraggable({
        id: field.code,
        data: {field: field, from: from},
    });

    const style = transform ? {
        zIndex: 999,
        transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
    } : undefined;

    if (queryMetaData == null) {
        return <Spin/>;
    } else {
        const displayName = queryMetaData.fields?.[field.code]?.name;
        const fieldCode = field.code
        if (!displayName) {
            return <Spin/>
        }
        return (
            <span ref={setNodeRef} style={style} {...listeners} {...attributes}>
            <Popover trigger="click"
                     placement="bottom"
                     content={<SelectFilter
                         field={field}
                         queryMetaData={queryMetaData}
                         appliedFilters={appliedFilters}
                         setAppliedFilters={setAppliedFilters}
                     />}
            >
                <Button className={`${buttonStyles['normal']} ${styles['select-button']}`} data-testid={fieldCode}>
                    <span className={styles['select-button-name']}>{displayName}</span>
                    <CaretDownOutlined className={styles['select-button-caret']}/>
                </Button>
            </Popover>
        </span>
        )
    }

}